module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_lerum-dffd7c1d5db2a7cf8ab3211dd7cc0a7a.png";